import React from "react";
import styled from "styled-components";
import { MatchSummary } from "../../components";

const divisionOrder = [
  "Paladines", "Campeones", "Mandobles", "Espadas Largas",
  "Hombre de Armas", "Alabarderos", "Milicias", "Piqueros", "Lanceros",
];
const phaseOrder = ["PLAYIN", "PLAYOFF"];
const playoffTypeOrder = ["Campeón división", "Ascenso", "Descenso"];

const HomePlayoffs = ({ matches }) => {
  if (!matches || matches.length === 0) return null;

  const sorted = [...matches].sort((a, b) => {
    return (
      divisionOrder.indexOf(a.divisionName) - divisionOrder.indexOf(b.divisionName) ||
      phaseOrder.indexOf(a.phase) - phaseOrder.indexOf(b.phase) ||
      playoffTypeOrder.indexOf(a.playoffType) - playoffTypeOrder.indexOf(b.playoffType)
    );
  });

  const grouped = sorted.reduce((acc, match) => {
    const key = `${match.divisionName}·${match.phase}·${match.playoffType}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(match);
    return acc;
  }, {});

  const groupKeys = Object.keys(grouped);

  return (
    <Wrapper className="v-anim-fade-up v-delay-4">
      <SectionLabel>FASE FINAL</SectionLabel>
      <SectionTitle>PLAYOFFS</SectionTitle>
      <Timeline>
        {groupKeys.map((key) => {
          const [divisionName, phase, playoffType] = key.split("·");
          return (
            <TimelineItem key={key}>
              <Marker>
                <Dot />
                <Line />
              </Marker>
              <Body>
                <GroupHeader>
                  <DivisionPill>{divisionName}</DivisionPill>
                  <PhaseTag>{phase} · {playoffType}</PhaseTag>
                </GroupHeader>
                <MatchGrid>
                  {grouped[key].map((match) => (
                    <MatchSummary key={match.matchId} {...match} playoff />
                  ))}
                </MatchGrid>
              </Body>
            </TimelineItem>
          );
        })}
      </Timeline>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100%;
  opacity: 0;
`;

const SectionLabel = styled.p`
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  color: var(--v-mint);
  margin: 0 0 0.25rem 0;
`;

const SectionTitle = styled.h2`
  font-family: var(--v-font-ui);
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  color: var(--v-white);
  margin: 0 0 1.5rem 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Timeline = styled.div`
  position: relative;
  padding-left: 2rem;

  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 0;
    bottom: 0;
    width: 1px;
    background: var(--v-uv);
    opacity: 0.4;
  }
`;

const TimelineItem = styled.div`
  display: flex;
  gap: 1.25rem;
  padding-bottom: 1.5rem;
  position: relative;
`;

const Marker = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 14px;
  flex-shrink: 0;
  margin-left: -2rem;
`;

const Dot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--v-mint);
  border: 2px solid var(--v-canvas);
  margin-top: 1.5rem;
  flex-shrink: 0;
  z-index: 1;
`;

const Line = styled.div`
  flex: 1;
  width: 1px;
  background: var(--v-uv);
  opacity: 0.4;
`;

const Body = styled.div`
  flex: 1;
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 1.25rem;
`;

const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const DivisionPill = styled.span`
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--v-black);
  background: var(--v-gold-bright);
  padding: 2px 10px;
  border-radius: 20px;
`;

const PhaseTag = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1.1px;
  color: var(--v-secondary);
`;

const MatchGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export default HomePlayoffs;
